<template>
  <v-container fluid>
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12">
        <v-toolbar color="white" flat>
          <v-toolbar-title class="text-h5">组件类型</v-toolbar-title>
        </v-toolbar>
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <v-card-actions class="pb-0 px-4">
            <v-subheader class="px-0">组件类型列表</v-subheader>
            <v-spacer></v-spacer>
            <v-btn outlined  color="primary" @click.stop="clickEdit('add')">
              <v-icon left>mdi-plus</v-icon>新增
            </v-btn>
          </v-card-actions>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="list"
              :items-per-page="5"
              class="elevation-1">
              <template v-slot:[`item.actions`]="{ item }">
                <!-- <v-btn class="ma-2 white--text" small  color="blue" @click="clickDetail(item)">查看</v-btn> -->
                <v-btn class="ma-2 white--text" small  color="blue" @click="clickEdit('edit', item)">编辑</v-btn>
                <v-btn class="ma-2 white--text" small  color="error" @click="clickDelete(item)">删除</v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="editDialog" persistent max-width="600px">
      <ValidationObserver ref="form">
        <v-card>
          <v-card-title style="padding-left: 60px; padding-bottom: 0; padding-top: 40px">
            <!-- <p>{{currentItem}}</p> -->
            <span class="headline">{{editType === 'edit' ? '编辑' : '添加'}}组件类型</span>
          </v-card-title>
          <v-card-text style="padding-right: 50px; padding-left: 50px; padding-bottom: 10px ">
            <v-container style="padding-top: 0">
              <v-form>
                <v-col cols="12" sm="12" md="12">
                  <ValidationProvider v-slot="{errors}" name="id" rules="required|numeric">
                    <v-text-field
                      label="id*"
                      v-model="editForm.id"
                      required
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <ValidationProvider v-slot="{errors}" name="名称" rules="required">
                    <v-text-field
                      label="名称*"
                      v-model="editForm.name"
                      required
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="normal darken-1" text @click="closeEditDialog">取消</v-btn>
            <v-btn color="primary darken-1" text @click="save" >保存</v-btn>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">删除组件类型</span>
        </v-card-title>
        <v-card-text class="pb-0" v-if="currentItem">
          确定要删除组件类型“{{currentItem.name}}"（id：{{currentItem.id}}）？<br>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="deleteDialog = false" text>取消</v-btn>
          <v-btn color="error" @click="deleteItem" text>确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { buildAxios } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, numeric } from 'vee-validate/dist/rules'
extend('numeric', {
  ...numeric,
  message: '该字段必须为纯数字！'
})

extend('required', {
  ...required,
  message: '该字段为必填项！'
})
const request = buildAxios()
export default {
  name: 'type',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      // uniName: '',
      editType: '',
      errors: 'error',
      editDialog: false,
      deleteDialog: false,
      headers: [
        { text: 'id', value: 'id' },
        { text: '名称', value: 'name' },
        // { text: '类型', value: 'comCode' },
        // { text: '用户类型', value: 'userType' },
        // { text: '平台类型', value: 'comCode' },
        // { text: '状态', value: 'status' },
        // { text: '组件图示', value: 'comIconUrl' },
        // { text: 'h5', value: 'isH5' },
        // { text: '小程序', value: 'isWxMini' },
        { text: '操作', value: 'actions' }
      ],
      // desserts: [],
      list: [],
      editForm: {
        id: null,
        name: ''
      },
      currentItem: null
    }
  },
  computed: {
  },
  watch: {
    list (newVal) {
      this.$store.commit('setComponentType', newVal)
    }
  },
  created () {
    this.getList()
  },
  methods: {
    clickEdit (type, item) {
      this.editType = type
      if (type === 'edit') {
        this.editForm = item
      }
      this.editDialog = true
      // this.$router.push({ name: 'appAdd' })
    },
    clickDelete (item) {
      this.currentItem = item
      this.deleteDialog = true
    },
    getList () {
      request.get('baseComponentTypeInfo/list')
        .then(res => {
          // this.desserts = []
          const data = res.data.data
          this.list = data
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    closeEditDialog () {
      this.editForm = {
        id: null,
        name: ''
      }
      this.editDialog = false
    },
    save () {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return
        }
        if (this.editType === 'add') {
          this.componentTypeAdd(this.editForm)
        } else if (this.editType === 'edit') {
          this.componentTypeUpdate(this.editForm)
        }
      })
    },
    componentTypeAdd (params) {
      request.post('baseComponentTypeInfo/add', params)
        .then(res => {
          console.log(res)
          this.getList()
          this.editDialog = false
          this.$emit('alert', {
            msg: '添加成功',
            type: 'success'
          })
          // this.parentAreaInfoList = res.data.data
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    componentTypeUpdate (params) {
      request.post('baseComponentTypeInfo/update', params)
        .then(res => {
          console.log(res)
          this.getList()
          this.editDialog = false
          this.$emit('alert', {
            msg: '编辑成功',
            type: 'success'
          })
          // this.parentAreaInfoList = res.data.data
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    // deleteItem () {
    //   // /cloud-api/baseComponentTypeInfo/delete
    //   // {
    //   //   id: this,this.currentItem
    //   // }
    //   this.componentTypeDelete({ id: this.currentItem.id })
    // },
    deleteItem () {
      request.post('baseComponentTypeInfo/delete', { id: this.currentItem.id })
        .then(res => {
          console.log(res)
          this.getList()
          this.deleteDialog = false
          this.$emit('alert', {
            msg: '删除成功',
            type: 'success'
          })
          // this.parentAreaInfoList = res.data.data
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    }
    //  /cloud-api/baseComponentTypeInfo/add
  },
  filters: {
  }
}
</script>
